import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { DistrictSchoolService } from "../report-services/district-school.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	selector: "app-district-suspension-workflow-detail",
	templateUrl: "./district-suspension-workflow-detail.component.html",
	styleUrls: ["./district-suspension-workflow-detail.component.css"],
})
export class DistrictSuspensionWorkflowDetailComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//private schoolService:SchoolService
		private districtschoolService: DistrictSchoolService,
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		DistrictSchoolID: 0,
		startDate: new Date(),
		endDate: new Date(),
		SortBy: "Date",
		ImageLogo: "",
	};

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;
	DistrictSchoolList: any = [];
	schoolList: any = [];
	ImageLogoList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 329;
	subscription: any;

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	ngOnInit() {
		// this.loadDistrictSchoolList()
		//this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onDistrictSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onDistrictSchoolChange(value) {
		this.report.SchoolID = value;
		this.report.DistrictSchoolID = value;
		this.loadLogolist();
	}

	private loadDistrictSchoolList() {
		this.report.DistrictSchoolID = 0;
		var result = this.districtschoolService.loadDistrictSchoolList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.DistrictSchoolList = response;

				if (this.DistrictSchoolList.length > 1) {
					// this.DistrictSchoolList.unshift({
					//     DistrictSchoolID: 0,
					//     DistrictSchoolDesc: "All Schools"
					// })
					this.report.DistrictSchoolID = this.DistrictSchoolList[0].SchoolID;
				} else {
					this.report.DistrictSchoolID = this.DistrictSchoolList[0].SchoolID;
				}
			},
			(error) => {}
		);
	}

	lstSortBy = [
		{
			SortBy: "Date",
			SortByDesc: "Date",
		},
		{
			SortBy: "Grade",
			SortByDesc: "Grade",
		},
		{
			SortBy: "Group",
			SortByDesc: "Group",
		},
		{
			SortBy: "Homeroom",
			SortByDesc: "Homeroom",
		},
		{
			SortBy: "Name",
			SortByDesc: "Name",
		},
	];

	//School List
	//   private loadSchoolist() {
	//     var result = this.schoolService.loadSchoolList("");
	//     result.subscribe(
	//         response => {
	//             this.schoolList = response;

	//             if (this.schoolList.length > 1) {
	//                 this.schoolList.unshift({
	//                     SchoolID: 0,
	//                     SchoolName: "All Schools"
	//                 })
	//             } else {
	//             }

	//         },
	//         error => {
	//         }
	//     )

	// }

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		// if (!this.report.DistrictSchoolID) {
		//   this.errorMessage = "Select the School";
		//   return
		// }

		var component = this;
		this.errorMessage = "";

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		var reportID = 329;

		// var strParam = "<ROOT><School SchoolID=\"" + this.report.DistrictSchoolID + "\"/></ROOT>|SchoolXML";
		// strParam += "," + moment(this.report.startDate).format("MM/DD/YYYY") + "|StartDate";
		// strParam += "," + moment(this.report.endDate).format("MM/DD/YYYY") + "|EndDate";
		// strParam += "," + this.report.SortBy + "|OrderBy";

		// var reportID = 385;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		strParam += this.report.DistrictSchoolID + "|DistrictSchoolID";
		strParam += "," + moment(this.report.startDate).format("MM/DD/YYYY") + "|WFStartDate";
		strParam += "," + moment(this.report.endDate).format("MM/DD/YYYY") + "|WFEndDate";
		strParam += "," + this.report.SortBy + "|OrderBy";
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
